import { render, staticRenderFns } from "./UploadWidget.vue?vue&type=template&id=c0b6e340&scoped=true&"
import script from "./UploadWidget.vue?vue&type=script&lang=js&"
export * from "./UploadWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b6e340",
  null
  
)

export default component.exports